export enum SendoutStatuses {
  CREATED = 'created',
  RUNNING = 'running',
  STOPPED = 'stopped',
  COMPLETED = 'completed',
  ERROR = 'error',
  PAUSED = 'paused',
}
